import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { I18nextProvider } from 'react-i18next'
import i18n from './i18n'
import '@fortawesome/fontawesome-free/css/all.min.css'

const rootElement = document.getElementById('root')
const dissidiaCdnUrl = process.env.REACT_APP_DISSIDIA_CDN_URL || 'https://dissidia.ai-pro.org/cdn'
window.React = React
window.ReactDOM = ReactDOM

// Dynamically import index.css
Promise.all([import('./index.css')]).then(() => {
  ReactDOM.createRoot(rootElement).render(
    <I18nextProvider i18n={i18n}>
      <React.StrictMode>
        {/* <Suspense fallback={null}> */}
        <App />
        {/* </Suspense> */}
      </React.StrictMode>
    </I18nextProvider>,
  )
})

setTimeout(() => {
  const link = document.createElement('link')
  link.rel = 'stylesheet'
  link.href = `${dissidiaCdnUrl}/dissidia-ui.css`
  document.head.insertBefore(link, document.head.firstChild)
  const script = document.createElement('script')
  script.src = `${dissidiaCdnUrl}/dissidia-ui.umd.js`
  script.defer = true
  document.body.appendChild(script)
}, 100)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
